import React, { useState, ReactElement } from "react";

import classNames from "classnames";
import ReactMarkdown from "react-markdown";

import { ClickableContentWrapper, If, MinusIcon } from "studio-design-system";
import { PlusIcon } from "studio-design-system";

import * as styles from "./FaqItem.css";

type Props = {
  answer: string;
  question: string;
  className?: string;
  darkTheme?: boolean;
};

export const FaqItem = ({ answer, question, className = "", darkTheme }: Props): ReactElement => {
  const [faqOpen, setFaqOpen] = useState(false);

  const toggleFaqOpen = () => {
    setFaqOpen(!faqOpen);
  };

  return (
    <ClickableContentWrapper
      onClick={toggleFaqOpen}
      className={classNames(styles.faq, darkTheme && styles.darkFaq, className)}
    >
      <div className={styles.faqQuestionContainer}>
        <div className={styles.faqQuestion}>{question}</div>
        <If condition={!faqOpen}>
          <PlusIcon
            className={classNames(darkTheme && styles.darkFaqPlus, styles.faqPlus)}
            width={16}
            height={16}
          />
        </If>
        <If condition={faqOpen}>
          <MinusIcon
            className={classNames(darkTheme && styles.darkFaqPlus, styles.faqPlus)}
            width={16}
            height={16}
          />
        </If>
      </div>
      <If condition={faqOpen}>
        <div className={classNames(darkTheme && styles.darkFaqAnswer, styles.faqAnswer)}>
          <ReactMarkdown>{answer}</ReactMarkdown>
        </div>
      </If>
    </ClickableContentWrapper>
  );
};
